module.exports = new __parcel__URL__("apple-logo.54e0d711.svg").toString();